import type { ReactElement } from 'react';
import { Link, useSearchParams } from 'react-router';
import { RequestPasswordResetForm, ResetPasswordForm } from '@/features/auth';
import { AuthPageShell } from '@/widgets/auth-page-shell';

/** 비밀번호 재설정 — 토큰이 없으면 메일 요청, 있으면 새 비밀번호 설정으로 분기한다. 로그인과 같은 전체 화면 인증 틀. */
export const ResetPasswordPage = (): ReactElement => {
  const [params] = useSearchParams();
  const token = params.get('token');

  return (
    <AuthPageShell
      title="Reset password"
      screenTitle="비밀번호 재설정"
      description={
        token ? '새 비밀번호를 설정해 주세요.' : '가입한 이메일로 재설정 링크를 보내드립니다.'
      }
      brandHeadline={
        <>
          비밀번호를 잊으셨나요?
          <br />
          메일로 바로 다시 설정하세요.
        </>
      }
      brandDescription="재설정 링크는 가입한 이메일로만 보내며, 변경하면 기존 로그인은 모두 해제됩니다."
    >
      {token ? <ResetPasswordForm token={token} /> : <RequestPasswordResetForm />}

      <p className="mt-6 text-center text-[13px]">
        <Link
          to="/sign-in"
          className="text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
        >
          로그인으로 돌아가기
        </Link>
      </p>
    </AuthPageShell>
  );
};
